import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./BLTInformation.styles.scss"

// Tabs 
import { InformationTab } from "./TabDetails/InformationTab";
import { CriminalHistoryTab } from "./TabDetails/CriminalHistoryTab";
import { LicenceSuspensionTab } from "./TabDetails/LicenceSuspensionTab";
import { WorkHistoryTab } from "./TabDetails/WorkHistoryTab";
import { 
    APPLICATION_MODE_NEW,
    APPLICATION_TYPE_COLLECTION_AGENCY,
    APPLICATION_TYPE_COLLECTOR,
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY,
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT,
    APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE,
    APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE,
    APPLICATION_TYPE_MORTGAGE_ASSOCIATE_BROKER_LICENCE,
    APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE,
    APPLICATION_TYPE_MORTGAGE_INDIVIDUAL_BROKER_LICENCE,
    APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE,
    ROUTE_PATH
} from "../../../app/constants";
import { IndividualInformationTab } from "./TabDetails/IndividualInformationTab";
import { BranchesTab } from "./TabDetails/BranchesTab";
import { AttachmentsTab } from "./TabDetails/AttachmentsTab";
// import { CollectorsTab } from "./TabDetails/CollectorsTab";
// import { TodoTab } from "./TabDetails/TodoTab";
import { SuretyBondTab } from "./TabDetails/SuretyBond/SuretyBondTab";
import { PaymentHistoryTab } from "./TabDetails/PaymentHistoryTab";
import { InternalNotesTab } from "./TabDetails/InternalNotesTab";
import { EditLicenceStatusTab } from "./TabDetails/EditLicenceStatusTab";
import { applicationTypeFromLicenceSubType } from "../../../redux/slice/applicationsUtils";
import { 
    AIRCheckTab,
    CriminalRecordsCheckTab,
    InsuranceProofRecordsCheckTab,
    SuretyBondDocumentTableTab
} from "./TabDetails/MortgageAttachments";
import { BrokerPreviousLicenceDetails } from './TabDetails/BrokerPreviousLicenceDetails'
import { BrokerEducationRequirementDetails } from "./TabDetails/BrokerEducationRequirementDetails";
import { BrokersTab } from "./TabDetails/BrokersTab";
import { TrustAccountTab } from "./TabDetails/TrustAccountTab";
import { ComplianceOfficerTab } from './TabDetails/ComplianceOfficerTab'
import { push } from "connected-react-router";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import AdministrativePenalties from "./TabDetails/AdministrativePenalties";
import { FinancialStatementsTab } from "./TabDetails/FinancialStatementsTab";

export const INTERNAL_NOTES_TAB = "Internal notes";
export const ADMINISTRATIVE_PENALTIES_TAB = "Administrative Penalties and Licence Conditions";
export const ADMINISTRATIVE_PENALTIES_NOTE_CATEGORY = "administrative_penalties";


const collectionAgencyTabs = [
    {key: "information", title: "Information", component: InformationTab},
    // {key: "collector", title:"Collector", component: CollectorsTab },
    {key: "payment",title: "Payment history", component:  PaymentHistoryTab },
    {key: "criminal_history",title: "Criminal history", component: CriminalHistoryTab },
    {key: "licence_suspensions", title: "Licence suspensions", component: LicenceSuspensionTab },
    {key: "work_history", title: "Work history", component: WorkHistoryTab },
    {key: "branches", title: "Branches", component: BranchesTab },
    {key: "attachments", title: "Attachments", component: AttachmentsTab },
    {key: "surety_bond",title: "Surety bond", component: SuretyBondTab },
    {key: "internal_notes", title: INTERNAL_NOTES_TAB, component: InternalNotesTab},
    {key: "edit_licence", title : "Edit licence", component : EditLicenceStatusTab, hidden: true}
]

const collectorTabs =[
    {key: "information",title: "Information", component: IndividualInformationTab},
    {key: "criminal_history",title: "Criminal history", component: CriminalHistoryTab},
    {key: "licence_suspensions", title: "Licence suspensions", component: LicenceSuspensionTab},
    {key: "payment_history",title: "Payment history", component:  PaymentHistoryTab},
    {key: "internal_notes",title: INTERNAL_NOTES_TAB, component: InternalNotesTab},
    {key: "edit_licence",title : "Edit licence", component : EditLicenceStatusTab, hidden: true}
]

const mortgageBrokerageTabs = [
  { key: "information", title: "Information", component: InformationTab },
  { key: "mortgage_brokers", title: "Mortgage Brokers", component: BrokersTab },
  { key: "payment_history", title: "Payment history", component: PaymentHistoryTab },
  { key: "air", title: "AIR", component: AIRCheckTab },
  {
    key: "criminal_record_checks",
    title: "Criminal record checks",
    component: CriminalRecordsCheckTab
  },
  {
    key: "eo_insurance",
    title: "Errors and omissions insurance",
    component: InsuranceProofRecordsCheckTab
  },
  { key: "internal_notes", title: INTERNAL_NOTES_TAB, component: InternalNotesTab },
  { key: "edit_licence", title: "Edit licence", component: EditLicenceStatusTab, hidden: true },
  {
    key: ADMINISTRATIVE_PENALTIES_NOTE_CATEGORY,
    title: ADMINISTRATIVE_PENALTIES_TAB,
    component: AdministrativePenalties,
    hiddenForInternalNoteTab: true
  }
];

const mortgageBrokerTabs = [
    {key: "information",title: "Information", component: IndividualInformationTab},
    {key: "previous_licences",title: "Previous licences",component : BrokerPreviousLicenceDetails},
    {key: "education_requirement",title: "Education requirement",component : BrokerEducationRequirementDetails},
    {key: "payment_history",title: "Payment history", component:  PaymentHistoryTab},
    {key: "criminal_record_checks",title: "Criminal record checks", component: CriminalRecordsCheckTab},
    {key: "internal_notes",title: INTERNAL_NOTES_TAB, component: InternalNotesTab},
    {key: "edit_licence",title: "Edit licence", component : EditLicenceStatusTab, hidden: true},
    {
        key: ADMINISTRATIVE_PENALTIES_NOTE_CATEGORY,
        title: ADMINISTRATIVE_PENALTIES_TAB,
        component: AdministrativePenalties,
        hiddenForInternalNoteTab: true
      }
]

const mortgageLenderTabs = [
    {key: "information",title: "Information", component: InformationTab},
    {key: "Compliance officer",title: "Compliance officer", component: ComplianceOfficerTab},
    {key: "payment_history",title: "Payment history", component:  PaymentHistoryTab},
    {key: "air",title: "AIR", component: AIRCheckTab},
    {key: "criminal_record_checks",title: "Criminal record checks", component: CriminalRecordsCheckTab},
    {key: "eo_insurance",title: "Errors and omissions insurance", component: InsuranceProofRecordsCheckTab},
    {key: "internal_notes",title: INTERNAL_NOTES_TAB, component: InternalNotesTab},
    {key: "edit_licence",title: "Edit licence", component : EditLicenceStatusTab, hidden: true},
    {
        key: ADMINISTRATIVE_PENALTIES_NOTE_CATEGORY,
        title: ADMINISTRATIVE_PENALTIES_TAB,
        component: AdministrativePenalties,
        hiddenForInternalNoteTab: true
      }
]

const mortgageAdministratorTabs = [
    {key: "information",title: "Information", component: InformationTab},
    {key: "Compliance officer",title: "Compliance officer", component: ComplianceOfficerTab},
    {key: "payment_history",title: "Payment history", component:  PaymentHistoryTab},
    {key: "air",title: "AIR", component: AIRCheckTab},
    {key: "criminal_record_checks",title: "Criminal record checks", component: CriminalRecordsCheckTab},
    {key: "eo_insurance",title: "Errors and omissions insurance", component: InsuranceProofRecordsCheckTab},
    {key: "Surety bond",title: "Surety bond", component: SuretyBondDocumentTableTab},
    {key: "financial_statements",title: "Financial statements", component: FinancialStatementsTab},
    {key: "Trust account",title: "Trust account", component: TrustAccountTab},
    {key: "internal_notes",title: INTERNAL_NOTES_TAB, component: InternalNotesTab},
    {key: "edit_licence",title: "Edit licence", component : EditLicenceStatusTab, hidden: true},
    {
        key: ADMINISTRATIVE_PENALTIES_NOTE_CATEGORY,
        title: ADMINISTRATIVE_PENALTIES_TAB,
        component: AdministrativePenalties,
        hiddenForInternalNoteTab: true
      }
]

const defaultTabs = [
    {key: "information",title: "Information", component: InformationTab},
    {key: "payment_history",title: "Payment history", component:  PaymentHistoryTab },
    {key: "internal_notes",title: INTERNAL_NOTES_TAB, component: InternalNotesTab},
    {key: "edit_licence",title: "Edit licence", component : EditLicenceStatusTab, hidden: true}
]

const getTabsForApplicationType = (applicationType, applicationMode) => {
    let tabs = []

    switch(applicationType) {
        case APPLICATION_TYPE_COLLECTION_AGENCY:
        case APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY:
            tabs = [...collectionAgencyTabs]
            break
        case APPLICATION_TYPE_COLLECTOR : 
        case APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT : 
            tabs = [...collectorTabs]
            break
        case APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE : 
            tabs = [...mortgageBrokerageTabs]
            break
        case APPLICATION_TYPE_MORTGAGE_PRINCIPAL_BROKER_LICENCE : 
        case APPLICATION_TYPE_MORTGAGE_ASSOCIATE_BROKER_LICENCE : 
        case APPLICATION_TYPE_MORTGAGE_INDIVIDUAL_BROKER_LICENCE : 
            tabs = [...mortgageBrokerTabs]
            break
        case APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE :
            tabs = [...mortgageAdministratorTabs] 
            break
        case APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE : 
            tabs = [...mortgageLenderTabs]
            break
        default : 
            tabs = [...defaultTabs]
            break
    }

    return tabs.map((tab) => ({
        ...tab,
        applicationType,
        applicationMode
    }))
}

// const getTabs = (tabs, applicationType, applicationMode) => {
//     return tabs.map((tab) => ({
//         ...tab,
//         applicationType,
//         applicationMode
//     }))
// }

export const InformationDetailPanel = (props) => {
    const {
        licenceApplication, 
        appData, 
        setActiveTabTitle, 
        isAgencyApplication, 
        showEditLicenceStatusTab,
        hideEditLicenceStatusTab,
        isArchiveApplication,
        activateTabKey,
    } = props;

    const dispatch = useDispatch();
    const qItemId = useParams().qItemId;
    const tabUrl = ROUTE_PATH.BLT_LICENCE_INFORMATION.replace(':qItemId',qItemId)
    const [activeTab, setActiveTab] = useState(0);
    
    const tabs = useMemo(() => {
        const applicationType = applicationTypeFromLicenceSubType(licenceApplication.licencingSubType)
        const applicationMode = APPLICATION_MODE_NEW
        return getTabsForApplicationType(applicationType, applicationMode)
    }, [licenceApplication.licencingSubType])

    useEffect(() => {
        let activeTabIndex = 0;
        if(showEditLicenceStatusTab) {
            const licenceTab = tabs.findIndex((t) => t.key === "edit_licence");
            if (licenceTab >= 0) {
                activeTabIndex = licenceTab;
            }
        } else {
            const requestedTabIndex = tabs.findIndex((t) => t.key === activateTabKey);
            if(requestedTabIndex >= 0) {
                activeTabIndex = requestedTabIndex;
            }
        }

        setActiveTab(activeTabIndex);
        setActiveTabTitle(tabs[activeTabIndex].title);
    }, [
        activeTab,
        setActiveTabTitle,
        tabs,
        showEditLicenceStatusTab,
        setActiveTab,
        activateTabKey
    ]);

    const TabDetailComponent = useMemo(() => tabs[activeTab].component, [tabs, activeTab])
    const applicationType = useMemo(() => tabs[activeTab].applicationType, [tabs, activeTab])
    const applicationMode = useMemo(() => tabs[activeTab].applicationMode, [tabs, activeTab])
    const activeTabTitle = useMemo(() => tabs[activeTab].title, [tabs, activeTab]);

    const tabC = useCallback(() => {
        const components = []

        tabs.forEach((tab, index) => {
            if(!tab.hidden) { 
                components.push(
                    <li key={index} onClick={() => {
                        
                        if(showEditLicenceStatusTab) {
                            hideEditLicenceStatusTab()
                        }
                        dispatch(push(tabUrl.replace(':tabKey',tab.key)));
                    }} className={`licence-tab ${index === activeTab ? "active" : ""}`}>{tab.title}</li>
                )
            }
        })

        return components
    }, [tabs, tabUrl, dispatch, activeTab, showEditLicenceStatusTab, hideEditLicenceStatusTab])

    return (
        <>
            <div className="col-md-3" >
                <ul className="licence-tabs fa-ul" >
                    {tabC()}
                </ul>
            </div>

            <div className="col-md-9">
                <TabDetailComponent 
                    internalNoteCategory={activeTabTitle}
                    isAgencyApplication={isAgencyApplication}
                    licenceApplication={licenceApplication}
                    appData={appData}
                    applicationType={applicationType}
                    applicationMode={applicationMode}
                    noteCategories={tabs}
                    isArchiveApplication={isArchiveApplication}
                    hideEditLicenceStatusTab={() => {
                        hideEditLicenceStatusTab()
                        dispatch(push(tabUrl.replace(':tabKey',tabs[0].key)));
                    }}
                />
                
                {
                   activeTabTitle !== ADMINISTRATIVE_PENALTIES_TAB && activeTabTitle !== INTERNAL_NOTES_TAB && (
                    <>
                        <InternalNotesTab 
                            isAgencyApplication={isAgencyApplication}
                            internalNoteCategory={activeTabTitle}
                            licenceApplication={licenceApplication}
                            noteCategories={tabs}
                            appData={appData}
                            applicationType={applicationType}
                            applicationMode={applicationMode}/>
                    </>
                   )
                }
                
            </div>
            
        </>
    )
}